export const experiences = [
  {
    position: "AI Intern",
    company: "Edunete AI Azure Program (Microsoft-supported)",
    duration: "",
    responsibilities: [
      "Completed AI bootcamps and Microsoft Skills Navigator courses",
      "Attended expert-led webinars with Microsoft AI professionals",
      "Contributed to real-world AI projects and earned credentials",
      "Learned: AI & ML fundamentals, Azure-based AI integration, Generative AI, Copilot technologies, and AI for sustainability"
    ]

  }
];